import { useEffect } from "react";
import Loader from "../../components/Loader/Loader";
import FinboxAPI from "../../services/finbox.api";
import { handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useDispatch } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { googleEvent_LOJ226 } from "../../lib/google-analytics";

export default function FinboxCreate() {
  const dispatch = useDispatch();

  useEffect(() => {
    generateFinboxURL();
  }, []);

  const generateFinboxURL = async () => {
    dispatch(setStepperDisable(true));
    const { finboxcreateUrlAPI } = new FinboxAPI();
    const res = await finboxcreateUrlAPI();
    if (res && res.statusCode === 200) {
      googleEvent_LOJ226();
      window.location.href = res.data.redirect_url;
    }
  };

  return <div>{handleShowContextualLoader("Please wait...")}</div>;
}
